module.exports = __webpack_public_path__ + "static/media/logoVertical.31ba971b.png";